module.exports = __webpack_public_path__ + "img/accra.585c20af.webp";